import './bulkResult.scss'
import React, { useState, useEffect } from 'react'
import { Container, Button, Typography } from '@material-ui/core'
import { Grid } from '@material-ui/core'
import { Check, Search, ShoppingCart } from '@material-ui/icons'
import Emoji from '../../assets/Images/Emoji2.png'

const { REACT_APP_STRAPI_API_URL } = process.env

function BulkResult() {
  const [searchDomainTitle, setSearchDomainTitle] = useState()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${REACT_APP_STRAPI_API_URL}/api/search-domain-titles`
        )
        const json = await response.json()
        setSearchDomainTitle(json?.data[0]?.attributes)
      } catch (error) {}
    }
    fetchData()
  }, [])

  const [registers, setRegister] = useState()
  const getRegisterData = async () => {
    const response = await fetch(
      `${REACT_APP_STRAPI_API_URL}/api/search-registration-processes?populate=img`
    ).then(response => response.json())
    setRegister(response?.data)
  }
  useEffect(() => {
    getRegisterData()
  }, [])

  const [bulkSeletions, setBulkSeletion] = useState()
  const getBulkSeletionData = async () => {
    const response = await fetch(
      `${REACT_APP_STRAPI_API_URL}/api/bulk-selections`
    ).then(response => response.json())
    setBulkSeletion(response?.data)
  }
  useEffect(() => {
    getBulkSeletionData()
  }, [])

  const [usBetters, setUsBetter] = useState()
  const getUsBetterData = async () => {
    const response = await fetch(
      `${REACT_APP_STRAPI_API_URL}/api/us-betters?populate=Image`
    ).then(response => response.json())
    setUsBetter(response?.data)
  }
  useEffect(() => {
    getUsBetterData()
  }, [])

  const [buttons, setButton] = useState()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${REACT_APP_STRAPI_API_URL}/api/button-apis`
        )
        const json = await response.json()
        setButton(json?.data[0]?.attributes)
      } catch (error) {}
    }
    fetchData()
  }, [])

  return (
    <>
      <div class="borderboxwrap">
        <div class="title-col1">
          <Typography variant="h1">{searchDomainTitle?.title}</Typography>
        </div>
        <form class="searchcolwrap">
          <input type="search" name="search" placeholder="Search" />
          <Button className="btnstyleSearch">
            <Search />
            {buttons?.knowmore}
          </Button>
        </form>
        <section className="domainboxwrap1">
          <Container>
            <Grid item xs={12}>
              <Grid container item xl={3} lg={3} md={12} sm={12} xs={12}>
                <img src={Emoji} alt=" " class="img-responsive ML-10-MBL" />
              </Grid>
              <Grid container item xl={3} lg={3} md={12} sm={12} xs={12}>
                <Typography variant="h4">FOREVER YOURS</Typography>
                <Typography variant="h2">
                  Melissa<span>.avax</span>
                </Typography>
                <Typography variant="h5">
                  1.050 AVAX<span>$154.98USD</span>
                </Typography>
                <Button className="btnstyleRegister">
                  <Check />
                  {buttons?.now}
                </Button>
              </Grid>
            </Grid>
          </Container>
        </section>
        <Container>
          <div class="greataltwrap">
            <Button class="btnstyle3">
              {searchDomainTitle?.bulkSeletionTitle}
            </Button>
            <ul className="greaaltlist">
              {bulkSeletions &&
                bulkSeletions.map(bulkSeletion => (
                  <li className="clearfix">
                    <div class="colleft">
                      <Typography variant="h3">
                        {' '}
                        {bulkSeletion.attributes.name}
                        <span>.avax</span>
                      </Typography>
                    </div>
                    <div class="colright">
                      <div class="infocol">
                        {bulkSeletion.attributes.value}
                        <Typography variant="h6">
                          {bulkSeletion.attributes.content}
                        </Typography>
                      </div>
                      <div class="rightcarticon">
                        <ShoppingCart />
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </Container>
        <section className="register">
          <Container>
            <Grid item xs={12}>
              <Typography variant="h1">
                {searchDomainTitle?.RegisterTitle}
              </Typography>
            </Grid>
            <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
              {registers &&
                registers.map(register => (
                  <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                    <div className="registerCard">
                      <div className="card">
                        <img
                          src={
                            REACT_APP_STRAPI_API_URL +
                            register?.attributes?.img?.data[0]?.attributes.url
                          }
                          alt=" "
                          class="img-fluid"
                        />
                        <Typography variant="h4">
                          {register.attributes.name}
                        </Typography>
                        <Typography component="p">
                          {register.attributes.content}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ))}
            </Grid>
          </Container>
        </section>
        <section className="usBetter">
          <Container>
            <Grid item xs={12}>
              <Typography variant="h1">
                {searchDomainTitle?.usbetterTitle}
              </Typography>
            </Grid>
            <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
              {usBetters &&
                usBetters.map(usBetter => (
                  <Grid container item xl={3} lg={3} md={3} sm={12} xs={12}>
                    <div className="usBetterDetail">
                      <img
                        src={
                          REACT_APP_STRAPI_API_URL +
                          usBetter?.attributes?.Image?.data[0]?.attributes.url
                        }
                        alt=" "
                        class="img-fluid"
                      />
                      <Typography variant="h2">
                        {usBetter.attributes.name}
                      </Typography>
                      <Typography component="p">
                        {usBetter.attributes.content}
                      </Typography>
                    </div>
                  </Grid>
                ))}
            </Grid>
          </Container>
        </section>
      </div>
    </>
  )
}
export default BulkResult
